import { Routes } from '@angular/router';
import { faFileSignature, faEnvelope, faGaugeHigh } from '@fortawesome/free-solid-svg-icons';

export default [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'  
    },
    {
        path: '',   
        data: {
            isFrontOffice: true,
            navItems: [
            {
                title: 'frontoffice.navigation.dashboard',
                icon: faGaugeHigh,
                type: 'link',
                path: '/portal/dashboard',
                permissions: []
            },
            {
                title: 'frontoffice.navigation.applications',
                icon: faFileSignature,
                type: 'link',
                path: '/portal/applications',
                permissions: []
            },
            {
                title: 'frontoffice.portal.requests.menu.messages',
                icon: faEnvelope,
                type: 'link',
                path: '/portal/messages',
                permissions: []
            } 
            ]
        },
        children: [ 
            {
                path: 'dashboard',
                data: {
                    title: "frontoffice.navigation.dashboard",
                    includeInHistory: true
                },
                loadComponent: () => import('./dashboard/portal-dashboard.component').then(c => c.DashboardComponent)
            },
            {
                path: 'applications',
                data: {
                    title: "frontoffice.navigation.applications",
                    includeInHistory: true
                },
                loadChildren: () => import('./applications/user-applications.route')
            },
            {
                path: 'messages',
                data: {
                    title: "frontoffice.portal.requests.menu.messages",
                    includeInHistory: true
                },
                loadChildren: () => import('./messages/portal-messages.routes')
            }
        ]
    },
    {
        path: 'profile',
        loadComponent: () => import('./profile/profile.component').then(c => c.ProfileComponent), 
        data: {
            title: "backoffice.navigation.myprofile"
        }
    },
    {
        path: 'license-plates/:id',
        loadComponent: () => import('./license-plates/license-plates.component').then(c => c.LicensePlatesComponent),
        data: {
            title: "frontoffice.navigation.licenseplates"
        }
    }  
] satisfies Routes;
